<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-toggle auto-hide="false">
            <img src="../assets/svg/logo-toolbar.svg">
          </ion-menu-toggle>
        </ion-buttons>
        <ion-buttons slot="end">
          <ion-button class="btn-back" @click="$router.back()">Back</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <bg :opaque="0"></bg>
      <ion-grid>
        <ion-row class="row-boxed mt-20">
          <ion-col size-xs="12">
            <ion-list>
              <ion-item v-for="(t, i) in templates" :key="'temp-'+i">
                <ion-avatar slot="end">
                  <ion-button @click="$router.push('/templates/edit/' + t.template)">Edit</ion-button>
                  <ion-button @click="() => deleteTemplate(t.template)">Delete</ion-button>
                </ion-avatar>
                <ion-label>{{ t.template }}</ion-label>
              </ion-item>
              <ion-item v-if="!templates.length">
                <ion-label>No template has been created</ion-label>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>

      </ion-grid>
      <loader :visible="loader"></loader>
    </ion-content>
  </ion-page>
</template>

<script>
import axios from "axios"
// import Vue from "vue"
export default {
  name: "Templates",
  data: function() {
    return {
      loader: true,
      templates: []
    }
  },
  methods: {
    deleteTemplate(name){
      return this.$ionic.alertController
      .create({
        header: 'Are you sure to delete "' + name + '" template?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            cssClass: 'secondary',
            handler: () => {
            },
          },
          {
            text: 'Delete',
            handler: async() => {
              this.loader = true
              axios.post(this.apiUrl + '/api/v1/delete-template', { api_token: this.$store.state.api_token, name: name })
              .then(() => {
                this.getTemplates()
              })
            },
          },
        ]
      })
      .then(a => a.present())
    },
    getTemplates() {
      axios.post(this.apiUrl + '/api/v1/get-templates', { api_token: this.$store.state.api_token })
      .then((response) => {
        let res = response.data
        if(res.data) {
          this.templates = res.data
        }
        this.loader = false;
      })

    }
  },
  mounted: async function() {
    this.getTemplates()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ion-avatar {
  min-width: 140px;
  text-align: right;
}
</style>